{
  "name": "supoui",
  "version": "0.0.1-SNAPSHOT",
  "private": true,
  "description": "Description for supoui",
  "license": "UNLICENSED",
  "type": "module",
  "scripts": {
    "ng": "ng",
    "start": "node --max_old_space_size=5000 ./node_modules/@angular/cli/bin/ng serve --configuration development && npm run version",
    "build": "node --max_old_space_size=5000 ./node_modules/@angular/cli/bin/ng build --configuration production",
    "prod": "node --max_old_space_size=5000  ./node_modules/@angular/cli/bin/ng build --configuration production && npm run version",
    "test": "ng test --browsers=Chrome ",
    "test:local": "ng test --karma-config karma.conf.local.cjs",
    "test:ci": "ng test  --browsers ChromeHeadless",
    "lint": "ng lint",
    "e2e": "ng e2e",
    "stats": "ng build --configuration production --stats-json",
    "bundle-report": "webpack-bundle-analyzer dist/Secca/stats.json",
    "version": "node_modules/.bin/replace-env src/environments/build.txt"
  },
  "dependencies": {
    "@angular-devkit/build-angular": "^19.2.15",
    "@angular/animations": "19.2.14",
    "@angular/cdk": "19.2.18",
    "@angular/common": "19.2.14",
    "@angular/compiler": "19.2.14",
    "@angular/core": "19.2.14",
    "@angular/forms": "19.2.14",
    "@angular/google-maps": "19.2.18",
    "@angular/material": "19.2.18",
    "@angular/material-moment-adapter": "19.2.18",
    "@angular/platform-browser": "19.2.14",
    "@angular/platform-browser-dynamic": "19.2.14",
    "@angular/router": "19.2.14",
    "@fortawesome/angular-fontawesome": "1.0.0",
    "@fortawesome/fontawesome-svg-core": "6.7.2",
    "@fortawesome/free-solid-svg-icons": "6.7.2",
    "@ng-bootstrap/ng-bootstrap": "^18.0.0",
    "@ng-select/ng-select": "^14.9.0",
    "@ngneat/until-destroy": "10.0.0",
    "@ngx-translate/core": "^16.0.4",
    "@ngx-translate/http-loader": "^16.0.1",
    "@videogular/ngx-videogular": "^10.0.1",
    "angularx-qrcode": "^19.0.0",
    "bootstrap": "5.3.2",
    "bootswatch": "5.3.6",
    "chart.js": "^4.5.0",
    "dropzone": "^6.0.0-beta.2",
    "file-saver": "2.0.5",
    "flag-icons": "^7.5.0",
    "heic2any": "0.0.4",
    "keycloak-angular": "^19.0.2",
    "keycloak-js": "^25.0.5",
    "luxon": "3.6.1",
    "moment": "2.30.1",
    "moment-timezone": "0.6.0",
    "ng-click-outside2": "^17.0.0",
    "ng-flex-layout": "^19.2.6",
    "ng2-charts": "^8.0.0",
    "ng2-pdf-viewer": "10.3.4",
    "ngx-cookie": "6.0.1",
    "ngx-currency": "^19.0.0",
    "ngx-device-detector": "^9.0.0",
    "ngx-dropzone-next": "^19.0.1",
    "ngx-infinite-scroll": "19.0.0",
    "ngx-logger": "5.0.12",
    "ngx-mask": "^19.0.7",
    "ngx-webstorage": "19.0.1",
    "rxjs": "7.8.2",
    "tslib": "2.4.0",
    "zone.js": "0.15.1"
  },
  "devDependencies": {
    "@angular/build": "^19.2.15",
    "@angular/cli": "19.2.15",
    "@angular/compiler-cli": "19.2.14",
    "@types/jasmine": "~6.0.0",
    "jasmine-core": "~6.2.0",
    "karma": "~6.4.0",
    "karma-chrome-launcher": "~3.2.0",
    "karma-coverage": "~2.2.0",
    "karma-jasmine": "~5.1.0",
    "karma-jasmine-html-reporter": "~2.2.0",
    "@openapitools/openapi-generator-cli": "1.0.10-4.2.3",
    "@types/core-js": "^2.5.6",
    "@types/file-saver": "2.0.5",
    "@types/google-maps": "3.2.3",
    "@types/luxon": "1.25.0",
    "@types/node": "^12.11.1",
    "@types/tableau": "^2.2.6",
    "@typescript-eslint/eslint-plugin": "5.36.1",
    "@typescript-eslint/parser": "5.36.1",
    "autoprefixer": "9.7.3",
    "browser-sync": "3.0.4",
    "codelyzer": "6.0.0",
    "css-loader": "3.3.2",
    "eslint": "8.23.0",
    "eslint-config-prettier": "8.5.0",
    "file-loader": "5.0.2",
    "html-loader": "0.5.5",
    "husky": "3.1.0",
    "lint-staged": "8.2.1",
    "mini-css-extract-plugin": "0.8.0",
    "postcss-loader": "3.0.0",
    "prettier": "1.19.1",
    "reflect-metadata": "0.1.13",
    "replace-env": "^1.0.4",
    "rimraf": "3.0.0",
    "sass": "1.23.7",
    "sass-loader": "8.0.0",
    "style-loader": "1.0.1",
    "swagger-ui-dist": "4.14.0",
    "thread-loader": "2.1.3",
    "to-string-loader": "1.1.6",
    "ts-loader": "6.2.1",
    "tslint": "~6.1.0",
    "typescript": "5.5.4",
    "webpack-bundle-analyzer": "4.6.1"
  }
}
